<div
	class="flex flex-col items-center justify-center gap-6 sm:gap-8 w-full min-h-dvh px-4 py-8 text-center"
>
	<span class="text-xl sm:text-2xl">Maintenance in progress</span>
	<img
		ngSrc="../../../../assets/img/coffee-break.png"
		alt="Coffee break"
		class="w-full max-w-[12rem] sm:max-w-[19rem] max-h-[45dvh] h-auto object-contain"
		height="875"
		width="608"
		priority
	/>
	<span class="text-xl sm:text-2xl">Perfect time to take a coffee break!</span>
	<img
		ngSrc="../../../../assets/img/onetag_logo_description.png"
		alt="OneTag Logo"
		class="w-full max-w-[16rem] sm:max-w-[26rem] h-auto"
		height="72"
		width="265"
	/>
</div>
